export default __webpack_public_path__ + "static/media/firework.ee38a785.svg";